export default {
  en: {
    copyright: 'The copyright of this event belongs to App',
    timeR: 'Count down ',
    timeR2: ' before the activity starts ',
    rank: 'Ranking',
    toptitle: 'KSA National Day',
    title: 'Celebration KSA',
    ruleDes:
      'To celebrate KSA National Day, we will be holding events from September 23rd to 30th. During the event, users send the following gifts, and the winner can get rewards',
    nav1: 'Ranking',
    nav2: 'Room',
    nav3: 'Reward',
    rule: 'Rules',
    share: 'Share',
    rulePop:
      'Activity time: 2022.09.23-2022.09.30<br/>1. The ranking is based on the coins of gift sent.<br/>2. Top 3 in every ranking can only have one piece of reward.<br/>3.If the user is top 3 in both rankings, he will be awarded according world ranking.<br/>4. This activity is irrelavant with Apple Company.<br/>5: This event includes two categories:<br/>KSA category: upgrade only through Saudi gifts in the event (<br/>World ranking: upgrade through world gifts)',
    world: 'World',
    country: 'KSA',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'days',
    eventgifts: 'Event Gifts',
    giftDesc: 'Points are only calculated for gifts from your own country',
    nationalTresures: 'National Treasures',
    rankings: 'Rankings',
    rewards: 'Rewards',
    treasures: 'Treasures',
    goldDesc: 'Now there are Gold Coins in the box',
    gd1: '1.The more event gifts sent during the event, the more gold coins accumulated in the treasure chest',
    gd2: '2.The gold coins of the treasure cheat will be randomly assigned after the event',
    gd3: '3.Leaderboard points to reach 200 or more to be ellgible to share the prize pool',
    luck: 'the 5 luckiest users of the last week',
    thisweek: "This week's National Star",
    copyRight: 'The right to explain the activity belongs to App',
    LastWeek: 'Last Week',
    ThisWeek: 'This Week',
    points: "Points are only counted for gifts from your nationallty to your country's events",
    medal: 'The medal becomes permanent after 3 times of acquisition',
    tips: 'Your current country is not yet open for the Country event,you can switch to another county to participate in the event',
    lw: "Last week's National Star",
    ac: 'Available Countries',
    allr: 'All rewards will be sent the next day (after confirmation)',
    service: 'If you have questions, please click here to contact customer service.',
    rewardtitle: 'Reward Rules',
    rewardRule: `
    - Regarding the headwear and the car : You can take a headwear and a car, whichever position the user won.<br/><br/>
    - Regarding the badge: The badge can only be taken in the case of completing the points of the position in which the user won, and it cannot be exchanged for any other badge for the rest of the centers.<br/><br/>
    - Regarding the coins: in the event that the user wins one of the centers, for example (a user won the first place, but his points, for example, 500k, means less than 800k, which are the requirements to obtain coins, in this case he will take the first place headwear + the first place car + the first place badge + and he can get  for second-place coins because he met the condition for second-place coins, which is more than 400k).<br/><br/>
    But in the event that he was a winner in the first place with less than 500k points, for example, 400k means less even than the points of the first badge , In this case, he will take the headwear and the car for the first place and the second place coins only, which means rewards without a badge.
    `
  },
  ar: {
    copyright: 'The copyright of this event belongs to App',
    timeR: 'العد التنازلي ',
    timeR2: 'قبل بدء النشاط',
    rank: 'التصنيف',
    toptitle: 'إحتفال السعودية',
    title: 'إحتفال السعودية',
    ruleDes:
      'للاحتفال باليوم الوطني للمملكة العربية السعودية ، سنعقد فعاليات من 23 إلى 30 سبتمبر.  خلال الحدث ، يرسل المستخدمون الهدايا التالية ، ويمكن للفائز الحصول على مكافآت',
    nav1: 'التصنيف',
    nav2: 'الغرف',
    nav3: 'المكافآت',
    rule: 'القواعد',
    rulePop:
      'وقت النشاط: 2022.09.23-2022.09.30<br/>1. يعتمد الترتيب على عملات الهدية المرسلة.<br/>2. يمكن أن تحصل المراكز الثلاثة الأولى في كل تصنيف على قطعة واحدة فقط من المكافأة.<br/>3. إذا كان المستخدم هو الأول في كلا الترتيبين ، فسيتم تكريمه وفقًا للترتيب العالمي.<br/>4. هذا النشاط غير مهم مع شركة Apple.<br/>5: يتضمن هذا الحدث تصنيفين : <br/> - التصنيف السعودي :  يتم ترقيته بواسطة هدايا السعودية التي في الحدث فقط ( ksa gift ) <br/>- التصنيف العالمي : يتم ترقيته بواسطة هدية العالم ( world gift )',
    world: 'العالم',
    country: 'KSA',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'أيام',

    eventgifts: 'هدايا الحدث',
    giftDesc: 'يتم احتساب النقاط فقط للهدايا من جنسيتك إلى الأحداث في بلدك',
    nationalTresures: 'الكنوز الوطنية',
    rankings: 'التصنيف',
    rewards: 'المكافئات',
    treasures: 'كنوز',
    goldDesc: 'الآن هناك عملات ذهبية في الصندوق',
    gd1: '1.كلما تم إرسال المزيد من الهدايا خلال الحدث ، زاد عدد العملات الذهبية المتراكمة في صندوق الكنز .',
    gd2: '2 سيتم تخصيص العملات الذهبية للكنز بشكل عشوائي بعد الحدث',
    gd3: '3- يتمتع أعلى 5 مستخدمين بفرصة الحصول على عملات ذهبية',
    luck: 'أسعد خمسة مستخدمين في الأسبوع الماضي',
    thisweek: 'نجمة الأسبوع الوطنية',
    copyRight: 'الحق في تفسير الأنشطة',
    LastWeek: 'الأسبوع الماضي',
    ThisWeek: 'هذا الأسبوع',
    points: 'يتم احتساب النقاط فقط للهدايا من وطنك إلى الأحداث في بلدك',
    medal: 'الميداليات المحجوزة بشكل دائم بعد الفوز 3 مرات',
    tips: 'بلدك الحالي ليس متاحاً بعد لبلدان  الحدث ، يمكنك التغيير إلى بلد أخر  للمشاركة في الحدث',
    lw: 'النجم الوطني للاسبوع الماضي',
    ac: 'البلدان المتاحة',
    allr: 'سيتم إرسال جميع المكافآت في اليوم التالي (بعد التأكيد)',
    service: 'إذا كانت لديك اي مشكله  ، يرجى النقر هنا للتواصل مع خدمة العملاء أحلام ',
    rewardtitle: 'قواعد المكافأة',
    rewardRule: `
- بخصوص الاطار و السيارة : يمكن اخد غطاء راس و سيارة اي مركز فاز فيه المستخدم <br/><br/>
- بخصوص الشارة : لا يمكن اخد الشارة الا في حالة اكمال نقاط المركز الذي فاز فيه المستخدم و لا يمكن استبدالها باي شاره اخرى لباقي المراكز <br/><br/>
- بخصوص الكونزات : في حالة فوز المستخدم باحد المراكز على سبيل المثال ( فاز مستخدم بالمركز الاول لكن نقاطه  مثلا 005k يعني اقل من 008k التي هي متطلبات الحصول على كونزات في هذه الحاله سياخد اطار المركز الاول + سيارة المركز الاول + شارة المركز الاول + و يمكنه الحصول على كونزات المركز الثاني لانه حقق شرط كونزات المركز الثاني الذي هو اكثر من 004k ) <br/><br/>
لكن في حالة كان فائز في المركز الاول بنقاط اقل من 005k مثلا 004k يعني اقل حتى من نقاط الشارة الاولى في هذه الحالة سياخد الاطار و السيارة للمركز الاول و كونزات المركز الثاني فقط يعني مكافئات بدون شارة 
    `
  },
  tr: {
    copyright: "Etkinliği yorumlama hakkı App'ye aittir.",
    timeR: 'Kalan Süre: ',
    timeR2: ' before the activity starts ',
    rank: 'Sıralama',
    toptitle: 'Suudi Arabistan Ulusal Günü',
    title: 'Kutlama Suudi Arabistan',
    ruleDes:
      "KSA Ulusal Günü'nü kutlamak için 23-30 Eylül tarihleri arasında etkinlikler düzenleyeceğiz. Etkinlik sırasında kullanıcılar aşağıdaki hediyeleri gönderir ve kazanan ödül alabilir",
    nav1: 'Sıralamalar',
    nav2: 'Oda',
    nav3: 'Ödüller',
    rule: 'Kurallar',
    rulePop:
      "Faaliyet zamanı: 2022.09.23-2022.09.30<br/>1. Sıralama, gönderilen hediye paralarına göre yapılır.<br/>2. Her sıralamada ilk 3'e sadece bir parça ödül verilebilir.<br/>3.Kullanıcı her iki sıralamada da ilk 3'teyse, dünya sıralamasına göre ödüllendirilecektir.<br/>4. Bu aktivitenin Apple Company ile ilgisi yoktur.",
    world: 'Dünya',
    country: 'KSA',
    notice: 'If your account country is changed during the activity, your trophy ranking will be cleared.',
    days: 'gün',

    eventgifts: 'Etkinlik Hediyeleri',
    giftDesc: 'Noktalar sadece kendi ülkenizin hediyeleri için hesaplanıyor.',
    nationalTresures: 'Ulusal Harcamalar',
    rankings: 'Sıralamalar',
    rewards: 'Ödüller',
    treasures: 'Maliyetler',
    goldDesc: 'Kutuda elmaslar var: ',
    gd1: '1.Olay sırasında daha fazla olay hediyeleri, hazine göğsünde daha fazla elmaslar toplandı.',
    gd2: '2.Hazinenin aldatıcısının elması olaydan sonra tesadüf olarak atacaktır.',
    gd3: '3.Liderbord ödül havuzunu paylaşmak için 200 ya da daha fazlasını sağlamak için gösteriyor.',
    luck: 'geçen hafta en şanslı kullanıcıların',
    thisweek: 'Bu Haftanın Ulusal Yıldızı',
    copyRight: "Etkinliği yorumlama hakkı App'ye aittir",
    LastWeek: 'Geçen hafta',
    ThisWeek: 'Bu hafta',
    points: 'Etkinliğe sadece bulunduğunuz ülke panelinin bayrağını atarak katılabilirsiniz.',
    medal: 'Medal 3 kez kazandıktan sonra kalıcı olur.',
    tips: 'Ülkünüz yarışma alanında değil, lütfen hesabınızı başka bir ülke değiştirin ya da yöneticinize ülkenizi eklemesini önerin.',
    lw: 'Geçen Haftanın Ulusal Yıldızı',
    ac: 'Mevcut ülkeler',
    allr: 'Sonraki gün tüm mükafatlar gönderilecek.',
    service: `Sorularınız varsa lütfen servisle iletişime geçmek için buraya tıklayın`,
    rewardtitle: 'Ödül Kuralları',
    rewardRule: `
    - Şapka ve araba ile ilgili : Kullanıcı hangi pozisyonda kazanırsa kazansın, şapka ve araba alabilirsiniz.<br/><br/>
    - Rozetle ilgili olarak: Rozet, yalnızca kullanıcının kazandığı pozisyonun puanlarını tamamlaması durumunda alınabilir ve diğer merkezler için başka bir rozetle değiştirilemez.<br/><br/ >
    - Madeni paralarla ilgili olarak: örneğin kullanıcının merkezlerden birini kazanması durumunda (bir kullanıcı birinciliği kazandı, ancak puanları, örneğin 500k, jeton elde etmek için gerekli olan 800k'dan az anlamına gelir, bu durumda birincilik şapkası + birincilik araba + birincilik rozeti + alacak ve ikincilik jetonları için 400 binden fazla olan ikincilik jeton koşulunu karşıladığı için ikincilik jetonları alabilecek.<br/ ><br/>
    Ancak ilk etapta 500 binden az puanla kazanan olması durumunda, örneğin 400k, ilk rozetin puanlarından bile daha az anlamına gelir, Bu durumda, şapkayı ve arabayı ilk etapta alacaktır. ve sadece ikinci sıradaki jetonlar, yani rozetsiz ödüller.
    `
  },
  pt:{
    copyright: 'Os direitos autorais deste evento pertencem ao App',
    timeR: 'Contagem regressiva ',
    timeR2: ' antes do início da atividade ',
    rank: 'Classificação',
    toptitle: 'Dia Nacional da KSA',
    title: 'Celebração KSA',
    ruleDes: 'Para celebrar o Dia Nacional da KSA, realizaremos eventos de 23 a 30 de setembro. Durante o evento, os usuários enviam os seguintes presentes, e o vencedor pode receber recompensas',
    nav1: 'Classificação',
    nav2: 'Sala',
    nav3: 'Recompensa',
    rule: 'Regras',
    share: 'Compartilhar',
    rulePop: 'Tempo da atividade: 2022.09.23-2022.09.30<br/>1. A classificação é baseada nas moedas dos presentes enviados.<br/>2. Os 3 primeiros em cada classificação podem receber apenas uma recompensa.<br/>3. Se o usuário ficar entre os 3 primeiros em ambas as classificações, ele será premiado conforme o ranking mundial.<br/>4. Este evento não tem relação com a Apple.<br/>5: Este evento inclui duas categorias:<br/>Categoria KSA: só pode ser atualizado com presentes sauditas durante o evento (<br/>Ranking mundial: atualizado com presentes mundiais)',
    world: 'Mundo',
    country: 'KSA',
    notice: 'Se o país da sua conta for alterado durante a atividade, sua classificação de troféus será apagada.',
    days: 'dias',
    eventgifts: 'Presentes do Evento',
    giftDesc: 'Os pontos são calculados apenas para presentes do seu próprio país',
    nationalTresures: 'Tesouros Nacionais',
    rankings: 'Classificações',
    rewards: 'Recompensas',
    treasures: 'Tesouros',
    goldDesc: 'Agora há Moedas de Ouro na caixa',
    gd1: '1. Quanto mais presentes do evento forem enviados durante o evento, mais moedas de ouro serão acumuladas no baú do tesouro',
    gd2: '2. As moedas de ouro do baú do tesouro serão atribuídas aleatoriamente após o evento',
    gd3: '3. A pontuação no ranking precisa alcançar 200 ou mais para ser elegível para compartilhar o prêmio',
    luck: 'os 5 usuários mais sortudos da última semana',
    thisweek: 'Estrela Nacional desta semana',
    copyRight: 'O direito de explicar a atividade pertence ao App',
    LastWeek: 'Semana Passada',
    ThisWeek: 'Esta Semana',
    points: 'Os pontos são contados apenas para presentes enviados do seu país para os eventos do seu país',
    medal: 'A medalha se torna permanente após 3 aquisições',
    tips: 'Seu país atual ainda não está aberto para o evento do País, você pode mudar para outro país para participar do evento',
    lw: 'Estrela Nacional da semana passada',
    ac: 'Países Disponíveis',
    allr: 'Todas as recompensas serão enviadas no dia seguinte (após confirmação)',
    service: 'Se você tiver dúvidas, clique aqui para entrar em contato com o atendimento ao cliente.',
    rewardtitle: 'Regras de Recompensa',
    rewardRule: `
    - Sobre os acessórios e o carro: Você pode pegar um acessório e um carro, de acordo com a posição que o usuário venceu.<br/><br/>
    - Sobre o emblema: O emblema só pode ser adquirido caso o usuário complete os pontos da posição que venceu, e não pode ser trocado por qualquer outro emblema dos outros centros.<br/><br/>
    - Sobre as moedas: se o usuário vencer um dos centros, por exemplo (um usuário venceu o primeiro lugar, mas seus pontos, por exemplo, 500k, são menores que 800k, que são os requisitos para obter moedas, neste caso ele pegará o acessório do primeiro lugar + o carro do primeiro lugar + o emblema do primeiro lugar + e poderá pegar as moedas do segundo lugar porque atendeu à condição das moedas do segundo lugar, que é mais de 400k).<br/><br/>
    Mas caso ele tenha vencido o primeiro lugar com menos de 500k pontos, por exemplo, 400k, o que é ainda menos que os pontos do primeiro emblema, neste caso ele pegará o acessório e o carro do primeiro lugar e as moedas do segundo lugar, o que significa recompensas sem emblema.
    `
  },
  id:{
    copyright: 'Hak cipta acara ini milik Aplikasi',
    timeR: 'Hitung mundur',
    timeR2: ' sebelum acara dimulai',
    rank: 'Peringkat',
    toptitle: 'Hari Nasional KSA',
    title: 'Perayaan KSA',
    ruleDes:
      'Untuk merayakan Hari Nasional KSA, kami akan mengadakan acara dari 23 hingga 30 September. Selama acara, pengguna mengirimkan hadiah berikut, dan pemenang dapat memperoleh hadiah',
    nav1: 'Peringkat',
    nav2: 'Kamar',
    nav3: 'Hadiah',
    rule: 'Aturan',
    share: 'Bagikan',
    rulePop:
      'Waktu acara: 2022.09.23-2022.09.30<br/>1. Peringkat didasarkan pada koin dari hadiah yang dikirimkan.<br/>2. Top 3 di setiap peringkat hanya dapat memperoleh satu hadiah.<br/>3. Jika pengguna berada di top 3 di kedua peringkat, ia akan diberikan berdasarkan peringkat dunia.<br/>4. Acara ini tidak ada kaitannya dengan Apple Company.<br/>5: Acara ini mencakup dua kategori:<br/>Kategori KSA: peningkatan hanya melalui hadiah Saudi dalam acara ini (<br/>Peringkat Dunia: peningkatan melalui hadiah dunia)',
    world: 'Dunia',
    country: 'KSA',
    notice: 'Jika negara akun Anda berubah selama acara, peringkat trofi Anda akan dibersihkan.',
    days: 'hari',
    eventgifts: 'Hadiah Acara',
    giftDesc: 'Poin hanya dihitung untuk hadiah dari negara Anda sendiri',
    nationalTresures: 'Harta Nasional',
    rankings: 'Peringkat',
    rewards: 'Hadiah',
    treasures: 'Harta',
    goldDesc: 'Sekarang ada Koin Emas di dalam kotak',
    gd1: '1. Semakin banyak hadiah acara yang dikirim selama acara, semakin banyak koin emas yang terkumpul di kotak harta',
    gd2: '2. Koin emas dari kotak harta akan dibagikan secara acak setelah acara selesai',
    gd3: '3. Poin papan peringkat mencapai 200 atau lebih untuk memenuhi syarat berbagi hadiah pool',
    luck: '5 pengguna paling beruntung minggu lalu',
    thisweek: "Bintang Nasional minggu ini",
    copyRight: 'Hak penjelasan acara ini milik Aplikasi',
    LastWeek: 'Minggu Lalu',
    ThisWeek: 'Minggu Ini',
    points: "Poin hanya dihitung untuk hadiah dari kewarganegaraan Anda untuk acara negara Anda",
    medal: 'Medali menjadi permanen setelah diperoleh 3 kali',
    tips: 'Negara Anda saat ini belum dibuka untuk acara Negara, Anda dapat beralih ke negara lain untuk berpartisipasi dalam acara',
    lw: "Bintang Nasional minggu lalu",
    ac: 'Negara yang Tersedia',
    allr: 'Semua hadiah akan dikirimkan pada hari berikutnya (setelah konfirmasi)',
    service: 'Jika Anda memiliki pertanyaan, klik di sini untuk menghubungi layanan pelanggan.',
    rewardtitle: 'Aturan Hadiah',
    rewardRule: `
    - Mengenai penutup kepala dan mobil: Anda dapat mengambil penutup kepala dan mobil, posisi mana pun yang dimenangkan pengguna.<br/><br/>
    - Mengenai lencana: Lencana hanya dapat diambil jika poin posisi yang dimenangkan pengguna telah diselesaikan, dan tidak dapat ditukar dengan lencana lain untuk pusat lainnya.<br/><br/>
    - Mengenai koin: dalam acara di mana pengguna memenangkan salah satu pusat, misalnya (seorang pengguna memenangkan tempat pertama, tetapi poinnya, misalnya 500k, berarti kurang dari 800k, yang merupakan persyaratan untuk mendapatkan koin, dalam hal ini dia akan mengambil penutup kepala tempat pertama + mobil tempat pertama + lencana tempat pertama + dan dia bisa mendapatkan koin untuk tempat kedua karena memenuhi syarat untuk koin tempat kedua, yaitu lebih dari 400k).<br/><br/>
    Namun, jika dia adalah pemenang tempat pertama dengan poin kurang dari 500k, misalnya 400k yang berarti kurang bahkan dari poin lencana pertama, dalam hal ini, dia akan mengambil penutup kepala dan mobil untuk tempat pertama dan koin tempat kedua saja, yang berarti hadiah tanpa lencana.
    `
  },
  ru:{
    "copyright": "Авторские права на это событие принадлежат приложению",
    "timeR": "Обратный отсчет",
    "timeR2": " до начала мероприятия",
    "rank": "Рейтинг",
    "toptitle": "Национальный день Саудовской Аравии",
    "title": "Празднование Саудовской Аравии",
    "ruleDes": "В честь Национального дня Саудовской Аравии мы проведем мероприятия с 23 по 30 сентября. Во время события пользователи отправляют следующие подарки, а победитель получает награды.",
    "nav1": "Рейтинг",
    "nav2": "Комната",
    "nav3": "Награда",
    "rule": "Правила",
    "share": "Поделиться",
    "rulePop":
      "Время мероприятия: 2022.09.23 - 2022.09.30<br/>" +
      "1. Рейтинг основан на количестве монет, потраченных на подарки.<br/>" +
      "2. Первые 3 участника в каждом рейтинге могут получить только одну награду.<br/>" +
      "3. Если пользователь входит в топ-3 в обоих рейтингах, награда присуждается по мировому рейтингу.<br/>" +
      "4. Это мероприятие не связано с компанией Apple.<br/>" +
      "5. В этом мероприятии есть две категории:<br/>" +
      "Категория KSA: обновление только через саудовские подарки в мероприятии<br/>" +
      "Мировой рейтинг: обновление через подарки со всего мира",
    "world": "Мир",
    "country": "Саудовская Аравия",
    "notice": "Если во время мероприятия страна вашего аккаунта изменится, ваш рейтинг трофеев будет сброшен.",
    "days": "дни",
    "eventgifts": "Подарки мероприятия",
    "giftDesc": "Очки засчитываются только за подарки из вашей страны.",
    "nationalTresures": "Национальные сокровища",
    "rankings": "Рейтинги",
    "rewards": "Награды",
    "treasures": "Сокровища",
    "goldDesc": "Сейчас в сундуке есть золотые монеты",
    "gd1": "1. Чем больше подарков отправлено во время мероприятия, тем больше золотых монет накапливается в сундуке.",
    "gd2": "2. Золотые монеты из сундука будут случайным образом распределены после окончания мероприятия.",
    "gd3": "3. Чтобы получить право на участие в призовом фонде, нужно набрать 200 или более очков в рейтинге.",
    "luck": "5 самых удачливых пользователей прошлой недели",
    "thisweek": "Национальная звезда этой недели",
    "copyRight": "Право на объяснение этого мероприятия принадлежит приложению",
    "LastWeek": "Прошлая неделя",
    "ThisWeek": "Эта неделя",
    "points": "Очки засчитываются только за подарки, отправленные на мероприятия вашей страны от вашей национальности.",
    "medal": "Медаль становится постоянной после 3-х получений.",
    "tips": "Ваша текущая страна пока не участвует в национальном мероприятии, вы можете переключиться на другую страну для участия.",
    "lw": "Национальная звезда прошлой недели",
    "ac": "Доступные страны",
    "allr": "Все награды будут отправлены на следующий день (после подтверждения).",
    "service": "Если у вас есть вопросы, нажмите здесь, чтобы связаться со службой поддержки.",
    "rewardtitle": "Правила наград",
    "rewardRule": `
    - О головном уборе и автомобиле: вы можете получить головной убор и автомобиль в зависимости от занятого места.<br/><br/>
    - О значке: значок можно получить только при выполнении условий по очкам для занятого места, и его нельзя обменять на другой значок для других мест.<br/><br/>
    - О монетах: если пользователь занимает одно из призовых мест, например, первое место, но у него 500k очков, а для получения монет требуется 800k, в этом случае он получит головной убор за первое место, автомобиль за первое место, значок за первое место и монеты за второе место, так как он соответствует требованиям (400k и более).<br/><br/>
    Но если пользователь занял первое место с менее чем 500k очков, например, 400k, что даже меньше минимального порога для значка первого места, в этом случае он получит только головной убор и автомобиль за первое место, а также монеты за второе место, то есть награды без значка.
    `
},
    uz:{
    "copyright": "Ushbu tadbirning mualliflik huquqi App-ga tegishli",
    "timeR": "Sanashni boshlash",
    "timeR2": " faoliyat boshlanishidan oldin",
    "rank": "Reyting",
    "toptitle": "Saudiya Arabistoni Milliy kuni",
    "title": "Saudiya bayrami",
    "ruleDes": "Saudiya Arabistoni Milliy kunini nishonlash uchun biz 23-sentabrdan 30-sentabrgacha tadbirlar o'tkazamiz. Tadbir davomida foydalanuvchilar quyidagi sovg'alarni yuborishadi va g'olib mukofot oladi.",
    "nav1": "Reyting",
    "nav2": "Xona",
    "nav3": "Mukofot",
    "rule": "Qoidalar",
    "share": "Ulashish",
    "rulePop":
      "Faoliyat vaqti: 2022.09.23 - 2022.09.30<br/>" +
      "1. Reyting yuborilgan sovg'alar uchun sarflangan tangalar asosida belgilanadi.<br/>" +
      "2. Har bir reytingning top 3 g'oliblari faqat bitta mukofot olishlari mumkin.<br/>" +
      "3. Agar foydalanuvchi har ikki reytingda ham top 3 talikda bo‘lsa, u global reyting bo‘yicha mukofot oladi.<br/>" +
      "4. Ushbu tadbir Apple kompaniyasi bilan bog‘liq emas.<br/>" +
      "5. Ushbu tadbir ikki toifani o‘z ichiga oladi:<br/>" +
      "Saudiya toifasi: faqat tadbir davomida Saudiya sovg‘alari orqali yangilanadi<br/>" +
      "Jahon reytingi: butun dunyo sovg‘alari orqali yangilanadi",
    "world": "Dunyo",
    "country": "Saudiya Arabistoni",
    "notice": "Agar faoliyat davomida hisobingiz mamlakati o'zgarsa, kubok reytingingiz tozalanadi.",
    "days": "kunlar",
    "eventgifts": "Tadbir sovg‘alari",
    "giftDesc": "Ballar faqat o‘z mamlakatingizdan yuborilgan sovg‘alar uchun hisoblanadi.",
    "nationalTresures": "Milliy xazinalar",
    "rankings": "Reytinglar",
    "rewards": "Mukofotlar",
    "treasures": "Xazinalar",
    "goldDesc": "Hozir qutida oltin tangalar mavjud",
    "gd1": "1. Tadbir davomida qancha ko‘p sovg‘a yuborilsa, xazina sandig‘ida shuncha ko‘p oltin tanga to‘planadi.",
    "gd2": "2. Tadbir tugagach, xazina sandig‘idagi oltin tangalar tasodifiy ravishda taqsimlanadi.",
    "gd3": "3. Mukofot fondini bo‘lishish huquqiga ega bo‘lish uchun reyting ballari 200 yoki undan yuqori bo‘lishi kerak.",
    "luck": "O‘tgan haftaning 5 ta eng omadli foydalanuvchisi",
    "thisweek": "Ushbu haftaning milliy yulduzi",
    "copyRight": "Ushbu faoliyatning izoh berish huquqi App-ga tegishli",
    "LastWeek": "O'tgan hafta",
    "ThisWeek": "Ushbu hafta",
    "points": "Ballar faqat sizning millatingizdan mamlakatingiz tadbirlari uchun yuborilgan sovg‘alar uchun hisoblanadi.",
    "medal": "Medal 3 marta qo‘lga kiritilgandan keyin doimiy bo‘lib qoladi.",
    "tips": "Hozirgi mamlakatingiz hali milliy tadbir uchun ochilmagan, tadbirda ishtirok etish uchun boshqa mamlakatni tanlashingiz mumkin.",
    "lw": "O‘tgan haftaning milliy yulduzi",
    "ac": "Mavjud mamlakatlar",
    "allr": "Barcha mukofotlar keyingi kuni (tasdiqlangandan so‘ng) yuboriladi.",
    "service": "Agar savollaringiz bo‘lsa, bu yerni bosing va mijozlarga xizmat ko‘rsatish bilan bog‘laning.",
    "rewardtitle": "Mukofot qoidalari",
    "rewardRule": `
    - Bosh kiyim va avtomobil haqida: foydalanuvchi egallagan o‘ringa qarab, bosh kiyim va avtomobil olishi mumkin.<br/><br/>
    - Nishon haqida: Nishon faqat foydalanuvchi egallagan o‘ringa mos keladigan ballar to‘planganda beriladi va boshqa o‘rinlar uchun boshqa nishonga almashtirib bo‘lmaydi.<br/><br/>
    - Tangalar haqida: agar foydalanuvchi biror o‘rinni egallasa, masalan, foydalanuvchi birinchi o‘rinda bo‘lsa, lekin uning ballari 500k bo‘lsa va bu tangalar olish talabi bo‘lgan 800k dan kam bo‘lsa, bu holda u birinchi o‘rin bosh kiyimi + birinchi o‘rin avtomobili + birinchi o‘rin nishonini oladi va u ikkinchi o‘rin tangalarini ham olishi mumkin, chunki u ikkinchi o‘rin talabi bo‘lgan 400k dan ortiq ballga ega.<br/><br/>
    - Agar foydalanuvchi birinchi o‘rinni egallagan bo‘lsa, lekin uning ballari 500k dan kam, masalan, 400k bo‘lsa va bu hatto birinchi o‘rin nishoni uchun ham yetarli bo‘lmasa, bu holda u faqat birinchi o‘rin bosh kiyimi va avtomobilini va ikkinchi o‘rin tangalarini oladi, ya’ni nishonsiz mukofot oladi.
    `
},
    fa:{
    "copyright": "حق نشر این رویداد متعلق به اپلیکیشن است",
    "timeR": "شمارش معکوس",
    "timeR2": " قبل از شروع رویداد",
    "rank": "رتبه‌بندی",
    "toptitle": "روز ملی عربستان سعودی",
    "title": "جشن عربستان سعودی",
    "ruleDes": "برای جشن گرفتن روز ملی عربستان سعودی، ما از ۲۳ تا ۳۰ سپتامبر رویدادهایی برگزار خواهیم کرد. در طول این رویداد، کاربران هدایای زیر را ارسال می‌کنند و برنده می‌تواند جوایز دریافت کند.",
    "nav1": "رتبه‌بندی",
    "nav2": "اتاق",
    "nav3": "پاداش",
    "rule": "قوانین",
    "share": "اشتراک‌گذاری",
    "rulePop":
      "زمان فعالیت: ۳۰.۰۹.۲۰۲۲ - ۲۳.۰۹.۲۰۲۲<br/>" +
      "۱. رتبه‌بندی بر اساس سکه‌های هدایا‌ی ارسال‌شده محاسبه می‌شود.<br/>" +
      "۲. نفرات برتر هر رتبه‌بندی فقط می‌توانند یک جایزه دریافت کنند.<br/>" +
      "۳. اگر کاربر در هر دو رتبه‌بندی جزو ۳ نفر برتر باشد، جایزه خود را بر اساس رتبه‌بندی جهانی دریافت خواهد کرد.<br/>" +
      "۴. این فعالیت هیچ ارتباطی با شرکت اپل ندارد.<br/>" +
      "۵. این رویداد شامل دو دسته‌بندی است:<br/>" +
      "دسته‌بندی عربستان: ارتقا فقط از طریق هدایای عربستان در طول رویداد<br/>" +
      "رتبه‌بندی جهانی: ارتقا از طریق هدایای جهانی",
    "world": "جهان",
    "country": "عربستان سعودی",
    "notice": "اگر کشور حساب شما در طول فعالیت تغییر کند، رتبه جام شما پاک خواهد شد.",
    "days": "روز",
    "eventgifts": "هدایای رویداد",
    "giftDesc": "امتیازات فقط برای هدایای کشور خودتان محاسبه می‌شود.",
    "nationalTresures": "گنجینه‌های ملی",
    "rankings": "رتبه‌بندی‌ها",
    "rewards": "جوایز",
    "treasures": "گنجینه‌ها",
    "goldDesc": "اکنون سکه‌های طلا در جعبه موجود هستند.",
    "gd1": "۱. هرچه در طول رویداد هدایای بیشتری ارسال کنید، سکه‌های بیشتری در صندوق گنج جمع‌آوری می‌شود.",
    "gd2": "۲. سکه‌های طلای صندوق گنج پس از پایان رویداد به‌صورت تصادفی توزیع خواهند شد.",
    "gd3": "۳. برای به‌اشتراک‌گذاری جایزه، امتیاز رتبه‌بندی باید حداقل ۲۰۰ باشد.",
    "luck": "۵ کاربر خوش‌شانس هفته گذشته",
    "thisweek": "ستاره ملی این هفته",
    "copyRight": "حق تفسیر این فعالیت متعلق به اپلیکیشن است",
    "LastWeek": "هفته گذشته",
    "ThisWeek": "این هفته",
    "points": "امتیازات فقط برای هدایای ملیتی شما برای رویدادهای کشور شما محاسبه می‌شود.",
    "medal": "مدال پس از ۳ بار دریافت دائمی می‌شود.",
    "tips": "کشور فعلی شما هنوز برای این رویداد باز نیست، می‌توانید کشور دیگری را انتخاب کنید تا در رویداد شرکت کنید.",
    "lw": "ستاره ملی هفته گذشته",
    "ac": "کشورهای در دسترس",
    "allr": "همه جوایز روز بعد (پس از تأیید) ارسال خواهند شد.",
    "service": "اگر سوالی دارید، اینجا کلیک کنید تا با پشتیبانی مشتری تماس بگیرید.",
    "rewardtitle": "قوانین پاداش",
    "rewardRule": `
    - درباره سرپوش و خودرو: بسته به موقعیتی که کاربر در آن برنده شده است، می‌تواند سرپوش و خودرو دریافت کند.<br/><br/>
    - درباره نشان: نشان فقط در صورتی قابل دریافت است که امتیازات موقعیت کسب‌شده تکمیل شده باشد و نمی‌توان آن را با نشان دیگری تعویض کرد.<br/><br/>
    - درباره سکه‌ها: در صورتی که کاربر یکی از رتبه‌ها را کسب کند، به عنوان مثال، اگر کاربر در رتبه اول قرار بگیرد اما امتیازات او ۵۰۰k باشد که کمتر از ۸۰۰k مورد نیاز برای دریافت سکه است، در این صورت او سرپوش رتبه اول + خودرو رتبه اول + نشان رتبه اول را دریافت می‌کند و همچنین می‌تواند سکه‌های رتبه دوم را دریافت کند، زیرا شرط امتیاز بیش از ۴۰۰k را دارد.<br/><br/>
    - اما اگر کاربر در رتبه اول قرار بگیرد ولی امتیازات او کمتر از ۵۰۰k باشد، مثلاً ۴۰۰k که حتی کمتر از حداقل امتیاز نشان اول است، در این صورت فقط سرپوش و خودرو رتبه اول و سکه‌های رتبه دوم را دریافت می‌کند، یعنی بدون نشان.
    `
}



}



// WEBPACK FOOTER //
// src/pages/activity/national/lang.js